var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemilikiTimProfesional(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 128.625,
    viewBox: "0 0 104 128.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.84,
    y1: 0.13,
    x2: 0.14,
    y2: 0.843,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0783d",
    stopOpacity: 0.482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-152 -907)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(152 907)",
    opacity: 0.266,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.278 678.404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.722 280.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.795,280.6H56.24a6.639,6.639,0,0,1,6.654,6.654v45.782a6.639,6.639,0,0,1-6.654,6.654H7.795a6.639,6.639,0,0,1-6.654-6.654V287.25A6.639,6.639,0,0,1,7.795,280.6Z",
    transform: "translate(-1.141 -280.596)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.994,280.6v11.7a3.119,3.119,0,0,0,3.128,3.123h8.647a3.119,3.119,0,0,0,3.128-3.123V280.6Z",
    transform: "translate(17.432 -280.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.225 38.658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.074,288.6a1.279,1.279,0,0,0,.123,2.555H8.825a1.277,1.277,0,1,0,0-2.555Z",
    transform: "translate(-2.805 -288.605)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.123,290.2a1.277,1.277,0,1,0,0,2.555h9.258a1.277,1.277,0,1,0,0-2.555Z",
    transform: "translate(-2.845 -282.49)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.113,289.47a2.554,2.554,0,0,0-2.459,2.876,70.011,70.011,0,0,0,2.724,12.162c.128.4.278.816.417,1.225h5.44c-.356-.936-.691-1.867-.983-2.781a65.53,65.53,0,0,1-2.527-11.182,2.554,2.554,0,0,0-2.612-2.3Z",
    transform: "translate(11.653 -285.3)",
    fill: "#ff9700"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.481,286.476a13.1,13.1,0,0,1-13,12.556c0,12.726,7.642,35.687,22.034,35.687,13.514,0,22.149-23.566,22.149-35.687a13.093,13.093,0,0,1-13-12.556Z",
    transform: "translate(23.104 -258.094)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.355,292.647c-3.458,12.6-7.621,17.978-13.065,20.835-5.049,2.525-10.277-1.906-10.277-1.906a2.554,2.554,0,0,0-4.265,1.492c3.072,3.217,6.767,5.278,11.07,5.278,10.634,0,18.223-14.581,20.985-26.707-1.879-1.557-3.9-.957-4.447,1.008Z",
    transform: "translate(31.798 -241.72)",
    fill: "#a29292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.945,10.575l-8.257,6.857-3.36-3.36a1.282,1.282,0,1,0-1.814,1.811L14.7,20.068a1.281,1.281,0,0,0,1.729.075l9.263-7.687C26.9,11.576,25.28,9.337,23.945,10.575Z",
    transform: "translate(35.224 36.52)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemilikiTimProfesional);
export default __webpack_public_path__ + "static/media/memiliki-tim-profesional.7e90c13cf1aa28524c3ba84c86e47e7b.svg";
export { ForwardRef as ReactComponent };